import { useContext } from 'react'
import { I18nContext } from '../context/I18nProvider'
//Comps
import Header from './Header/Header'
import Footer from './Footer/Footer'
import Whatsapp from '../components/whatsapp/Whatsapp'

const Layout = ({ children }) => {
    const { language } = useContext(I18nContext)

    return (
        <div className="incoming-tower-travel">
            <Header language={language} />
            {children}
            <Whatsapp />
            <Footer language={language} />
        </div>
    )
}

export default Layout
